
<div [ngClass]="[progressBarInput.type === '1' ? 'progress-orange' : (progressBarInput.type === '2' ? 'progress-success' : (progressBarInput.type === '3' ? 'progress-error' : (progressBarInput.type === '4' ? 'progress-warning' : ''))) ]">
    <ngb-progressbar [attr.id]="progressBarInput.id" [value]="progressBarInput.progressValue"></ngb-progressbar>
    <!-- Guarded: without a `subText` this element must not exist at all, or every existing progress
         bar gains an empty line under it. -->
    @if(progressBarInput.subText) {
    <p [ngClass]="{'progress-bar-text': true, 'text-right': progressBarInput.subTextRight}">{{ progressBarInput.subText }}</p>
    }
</div>